import { CoreItem, CoreItemBackend } from '../core-item/core-item';

export interface TaskBackend extends CoreItemBackend {
  type: TaskType;
  unsafeSubData?: TaskUnsafeSubData;
  publicSubData?: TaskPublicSubData;
}
export interface Task extends CoreItem {
  unsafeSubData: TaskUnsafeSubData;
  publicSubData: TaskPublicSubData;

  frontendData?: TaskFrontendData;
}

export interface TaskFrontendData {
  sessionTemplateIdAndSessionIdSet?: Map<string, Set<string>>;
}

export enum TaskType {
  default = 'default',
  target = 'target',
}

export interface TaskUnsafeSubData {}

export interface TaskPublicSubData {}
